import Vue from 'vue';
import { debounce } from '~/mixins/debounce';

Vue.directive('debounce', {
	bind: function (el, binding) {
		el.oninput = debounce(function () {
			el.dispatchEvent(new Event('change'));
		}, parseInt(binding.value) || 500);
	},
});
